import { z } from 'zod';

export const OrgContextSchema = z.object({
  type: z.string().optional(),
  orgSlug: z.string().optional(),
  orgId: z.string().optional(),
}).passthrough();

export const GuidedFlowSchema = z.object({
  domain: z.string().optional(),
  kbTitle: z.string().optional(),
  lastStep: z.enum(['knowledge', 'data', 'schema', 'pages']).optional(),
}).passthrough();

export const TabLockSchema = z.object({
  tabId: z.string(),
  timestamp: z.number(),
});

export const ViewerPreferencesSchema = z.object({
  showInfo: z.boolean().optional(),
  showNavigation: z.boolean().optional(),
  darkMode: z.boolean().optional(),
  showComponentLabels: z.boolean().optional(),
  allowInteraction: z.boolean().optional(),
  enableVirtualization: z.boolean().optional(),
}).passthrough();

export const VersioningPreferencesSchema = z.object({
  autoSave: z.boolean().optional(),
  autoSaveInterval: z.number().optional(),
  showAllVersions: z.boolean().optional(),
  showBranchVersionsOnly: z.boolean().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.string().optional(),
  enableVersionCaching: z.boolean().optional(),
}).passthrough();

export const RecentColorsSchema = z.array(z.string());

export const RecentCommandsSchema = z.array(z.object({
  id: z.string(),
  label: z.string(),
}).passthrough());
